import { Card, CardContent, CardHeader, Button } from "@pushpress/pushpress-ui";
import { AlertTriangle } from "lucide-react";

export default function ErrorScreen({ refetch }: { refetch: () => void }) {
  return (
    <div className="tw-h-auto tw-w-auto tw-flex tw-items-center tw-justify-center tw-p-4">
      <Card className="tw-w-full tw-max-w-md">
        <CardHeader>
          <div className="tw-flex tw-space-x-2 tw-space-y-2 tw-flex-col tw-items-center">
            <AlertTriangle className="tw-h-6 tw-w-6 tw-text-orange-500" />
            <h6 className="tw-flex tw-justify-center tw-space-x-2 tw-mb-4">
              We couldn&apos;t load the payment page.
            </h6>
          </div>
        </CardHeader>
        <CardContent>
          <div className="tw-flex tw-flex-col tw-space-y-2">
            <p className="tw-flex tw-justify-center tw-space-x-2 tw-text-gray-600 tw-mb-4">
              This could be due to a network issue or a temporary problem on our
              end.
            </p>
            <Button size="sm" onClick={() => refetch()}>
              Retry
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
